import { render, staticRenderFns } from "./QuestionnaireEdit.vue?vue&type=template&id=673e0ade&"
import script from "./QuestionnaireEdit.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireEdit.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireEdit.vue?vue&type=style&index=0&id=673e0ade&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports